export function PrimaryPaymentBlock(page) {
  const block = this;

  block.init = params => {
    block.container = params.container;
    block.header = block.container.querySelector('.dkt-block-header');
    block.content = block.container.querySelector('.dkt-block-content');
    block.name = block.container.getAttribute('data-payment-name');
    block.id = block.container.getAttribute('data-payment-type-id');
    block.multiEnabled = block.container.getAttribute('data-multi-enabled');
    block.isExpress = params.isExpress || false;
    block.state = {
      selected: params.selected || false,
      hasError: false,
      submittable: false
    };
    block.events();

    if (block.state.selected === true) {
      block.select();
    }
  };

  block.events = () => {
    if (block.isExpress === false) {
      block.header.addEventListener('click', block.select);
    }
    document.addEventListener('PrimaryPaymentBlockSelected', block.unselect);
  };

  block.select = event => {
    if ((block.state.selected === false && event) || !event) {
      document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected',
        { bubbles: false, cancelable: false, detail: { 'multiEnabled': block.multiEnabled } }));
      $(block.content).slideDown('fast', () => {
        block.container.classList.add('dkt-block--open');
      });
      block.container.classList.add('dkt-block--selected');
      block.state.selected = true;
      if (block.isExpress === false) {
        page.enableButton();
      }
    }
  };

  block.unselect = () => {
    block.container.classList.remove('dkt-block--selected');
    block.state.selected = false;
    $(block.content).slideUp('fast', () => {
      block.container.classList.remove('dkt-block--open');
    });
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-primary-block.js